import styled from 'styled-components'

export const FormWrapper = styled.div`
  background-color: #ffffff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin: 20px 0;
  width: 100%;
`

export const FieldsetContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`

export const FieldsetWrapper = styled.fieldset`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  transition: box-shadow 0.3s ease;
  flex: 1 1 calc(50% - 10px);
  min-width: 300px;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    margin-bottom: 0;
    padding: 10px 15px;
    min-width: auto;
  }
`

export const LegendText = styled.legend`
  font-weight: 700;
  color: #000000;
  padding: 0 12px;
  font-size: 1.1em;

  @media (max-width: 480px) {
    font-size: 1em;
  }
`

export const FieldRow = styled.div`
  margin-bottom: 12px;

  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`

export const FieldLabel = styled.label`
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #000000;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const LabelText = styled.span`
  display: inline-block;
  width: 300px;
  flex-shrink: 0;
  padding-right: 10px;
  font-weight: normal;
  text-align: left;

  @media (max-width: 768px) {
    width: auto;
    padding-right: 0;
    margin-bottom: 5px;
  }
`

export const InputWrapper = styled.div`
  flex-grow: 1;
  max-width: 350px;

  .ant-input,
  .ant-select .ant-select-selector,
  .ant-switch {
    border-radius: 6px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }

  .ant-input:focus,
  .ant-select-focused .ant-select-selector {
    border-color: #3a1c46;
    box-shadow: 0 0 0 0.2rem rgba(58, 28, 70, 0.25);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
`